<template>
  <div
    class="org-item"
    :class="{ 'close-pro': !isOpen }"
    @click="projectList"
  >
    <i
      class="icon iconfont iconicon-test24"
      :class="{'founder': isAdmin}"
    />
    <span class="org-name">
      {{ proItemData.projectname }}
    </span>
    <i
      v-if="isAdmin"
      class="icon iconfont iconicon-test27"
      @click.prevent.stop="showActive"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  components: {
  },
  props: {
    proItemData: {
      type: Object,
      default () {
        return {}
      }
    },
    baseinfo: {
      type: Object,
      default () {
        return {}
      }
    },
    cid: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isShow: true
    }
  },
  computed: {
    isAdmin () {
      return this.baseinfo.isfounder * 1 || this.baseinfo.isadmin * 1
    },
    isOpen () {
      return this.proItemData.status * 1 === 1
    },
    pid () {
      return this.$store.state.pid || this.$route.params.pid
    },
    type () {
      const { type = 'inquery' } = this.$route.query
      return type
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('organization/org', ['ajaxClosePro', 'ajaxOpenPro', 'projectToLink']),
    async projectList () {
      const { type } = this
      const pType = type === 'member' ? 2 : 1
      if (this.isOpen) {
        if (type === 'inquery') {
          const chain = await this.projectToLink()
          chain.params({ cid: this.$route.query.cid, projectid: this.proItemData.projectid, pType })
            .onSuccess((raw) => {
              const { Project: tid } = raw
              this.$store.commit('setPid', tid)

              const pid = raw.Project // this.$store.state.pid
              this.$router.push({
                name: 'ProjectIndex', // 'ProjectIndex','MemberPro'
                params: {
                  pid
                },
                query: {
                  cid: this.$route.query.cid
                }
              // query: {
              //   name: this.proItemData.projectname,
              //   cid: this.$route.query.cid
              // }
              })
            })
            .fetch()
        } else {
          this.$router.push({ name: 'mobileCommon' })
        }
      } else {
        const toast = this.$createToast({
          time: 2000,
          txt: this.$t('message["1327"]') + '！',
          type: 'txt'
        })
        toast.show()
      }
    },
    showActive () {
      let arr = []
      const { type } = this
      const pType = type === 'inquery' ? 1 : 2
      if (this.isOpen) {
        arr = [
          {
            content: this.$t('message["1398"]')
          },
          {
            content: this.$t('message["405"]')
          },
          {
            content: this.$t('message["978"]')
          }
        ]
      } else {
        arr = [
          {
            content: this.$t('message["1620"]')
          },
          {
            content: this.$t('message["978"]')
          }
        ]
      }
      this.$createActionSheet({
        title: '',
        active: 0,
        data: arr,
        onSelect: async (item, index) => {
          if (item.content === this.$t('message["1398"]')) {
            this.$router.push({
              name: 'ProjectIndexPc',
              query: {
                page: 5,
                projectid: this.proItemData.projectid,
                cid: this.cid,
                projectname: this.proItemData.projectname,
                comname: this.baseinfo.comname,
                type
              } })
          } else if (item.content === this.$t('message["405"]')) {
            this.$createDialog({
              type: 'confirm',
              icon: '',
              title: this.$t('message["405"]'),
              content: this.$t('message["407"]'),
              confirmBtn: {
                text: this.$t('message["915"]'),
                active: true,
                disabled: false,
                href: 'javascript:;'
              },
              cancelBtn: {
                text: this.$t('message["896"]'),
                active: false,
                disabled: false,
                href: 'javascript:;'
              },
              onConfirm: async () => {
                const chain = await this.ajaxClosePro({ cid: this.cid })
                chain.params({ cid: this.cid, projectid: this.proItemData.projectid, pType })
                  .onSuccess(raw => {
                    this.proItemData.status = -1
                    this.$router.push({
                      name: 'ProjectIndexPc',
                      query: {
                        page: 2,
                        cid: this.$route.query.cid,
                        type
                      } })
                  })
                  .onNetSuccess((res) => {
                    const toast = this.$createToast({
                      time: 2000,
                      txt: res.data.message || res.data.payload[0].message,
                      type: 'txt'
                    })
                    toast.show()
                  })
                  .config({ tip: false })
                  .fetch()
              },
              onCancel: () => {
              }
            }).show()
          } else if (item.content === this.$t('message["1620"]')) {
            const chain = await this.ajaxOpenPro({ cid: this.cid })
            chain.params({ cid: this.cid, projectid: this.proItemData.projectid, pType })
              .onSuccess(raw => {
                this.proItemData.status = 1
                this.$router.push({
                  name: 'ProjectIndexPc',
                  query: {
                    page: 2,
                    cid: this.$route.query.cid,
                    type
                  } })
              })
              .onNetSuccess((res) => {
                const toast = this.$createToast({
                  time: 2000,
                  txt: res.data.message || res.data.payload[0].message,
                  type: 'txt'
                })
                toast.show()
              })
              .config({ tip: false })
              .fetch()
          } else if (item.content === this.$t('message["978"]')) {
            this.$router.push({
              name: 'ProjectIndexPc',
              query: {
                page: 6,
                projectid: this.proItemData.projectid,
                cid: this.cid,
                projectname: this.proItemData.projectname,
                type
              } })
          }
        },
        onCancel: () => {
        }
      }).show()
    }
  }
}
</script>
<style lang="scss" scoped>
  .close-pro {
    opacity: 0.5
  }
</style>
